import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiChangeKind } from '@euler/model/bi/change-set';
import {
  ArrowUpDown,
  CalendarRange,
  CirclePlus,
  LucideIcon,
  Palette,
  PencilLine,
  Trash2,
  Type,
} from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';

const kIcons: Record<BiChangeKind, { icon: LucideIcon; color: string }> = {
  [BiChangeKind.CardAdded]: { icon: CirclePlus, color: aiColors.green },
  [BiChangeKind.CardUpdated]: { icon: PencilLine, color: aiColors.amber },
  [BiChangeKind.CardRemoved]: { icon: Trash2, color: aiColors.red },
  [BiChangeKind.CardMoved]: { icon: ArrowUpDown, color: aiColors.blue },
  [BiChangeKind.DashboardRenamed]: { icon: Type, color: aiColors.violet },
  [BiChangeKind.FiltersChanged]: {
    icon: CalendarRange,
    color: aiColors.violet,
  },
  [BiChangeKind.PaletteChanged]: { icon: Palette, color: aiColors.violet },
};

/** One line of the diff: what happens to which card. */
export const ChangeLine = memo(
  ({ kind, text }: { kind: BiChangeKind; text: string }) => {
    const { rpx } = useResponsiveContext();
    const { icon: Icon, color } = kIcons[kind];
    return (
      <View style={{ flexDirection: 'row', gap: rpx(8) }}>
        <View style={{ paddingTop: rpx(2) }}>
          <Icon size={14} color={color} />
        </View>
        <Typography.Text
          size={rpx(13)}
          lineHeight={rpx(19)}
          color={aiColors.foreground}
          style={{ flex: 1 }}
        >
          {text}
        </Typography.Text>
      </View>
    );
  },
);
